import { apiDelete } from '../support/helpers/ApiConnection.Helper';

export function deleteProductInformationById(id: number, abortSignal: AbortSignal): Promise<void> {
    return apiDelete<void>('/product-information', id, abortSignal);
}
